import {ListResponseModel} from "./ListResponseModel"

export type UsersResponse = ListResponseModel<UserResponse>

export type UserResponse = {
    id: number
    name: string
    phone: string
    email: string
    telegramId: string
    verify: boolean
    active: boolean
    notify: UserNotifyState
    idUserType: number
    nameUserType: string
    idUserGroup: number
    nameUserGroup: string
    idCompany: number
    nameCompany: string
    createdAt: string
    updatedAt: string
}

export enum UserNotifyState {
    Disable = 0,
    Enable = 1,
    EnableWithSound = 2,
}